import React from 'react';
export function Footer() {
  return <footer className="py-12 px-6 bg-gray-50 border-t border-gray-200" data-id="element-42">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-43">
        <div className="text-navy font-serif font-bold text-lg tracking-wide" data-id="element-44">
          MFC Investco
        </div>

      

        <div className="text-xs text-gray-400" data-id="element-45">
          © {new Date().getFullYear()} MFC Investco
        </div>
      </div>
    </footer>;
}